module.exports = {"TXTMOB_Exclusive":{"id":"TXTMOB_Exclusive","defaultMessage":"Exklusiv","flags":["TRACK"],"track":"Exclusive"}}